import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl,FormGroupDirective } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { NotificationServices } from '../../../../appauth/notification/notificatio.services';
import { CustomValidators } from 'ng2-validation';
import { Repuestosvaloraciones } from '../../modelo-repuestosvaloracione/repuestosvaloraciones.model';
import { RepuestosvaloracionesServices } from '../../modelo-repuestosvaloracione/servicios-repuestosvaloraciones.services';
import { Valoraciones } from '../../../reparar-valoraciones/modelo-valoracione/valoraciones.model';
import { ValoracionesServices } from '../../../reparar-valoraciones/modelo-valoracione/servicios-valoraciones.services';
import { Repuestos } from '../../../reparar-repuestos/modelo-repuesto/repuestos.model';
import { RepuestosServices } from '../../../reparar-repuestos/modelo-repuesto/servicios-repuestos.services';

@Component({
	selector: 'app-insertarrepuestosvaloracionemodal',
	templateUrl: './insertarrepuestosvaloracionemodal.component.html',
	styleUrls: ['./insertarrepuestosvaloracionemodal.component.scss']
})

export class InsertarRepuestosvaloracioneModalComponent implements OnInit {
	breakpoint: number;
	ratio = '4:1';
	public dataValoraciones:any;
	public dataRepuestos:any;
	public formInsertarRepuestosvaloracione: FormGroup;

	constructor(private fb: FormBuilder,
		public dialogRef: MatDialogRef <InsertarRepuestosvaloracioneModalComponent>,
		private servicioRepuestosvaloracione:RepuestosvaloracionesServices,
		private servicioValoracione:ValoracionesServices,
		private servicioRepuesto:RepuestosServices,
		private mensajes:NotificationServices,) { }

	ngOnInit() {
	
		this.breakpoint = (window.innerWidth <= 800) ? 1 : 2;
		this.ratio=(window.innerWidth <= 800) ? '4:1.6':'4:1';
		if(this.breakpoint!=1){
			this.dialogRef.updateSize("50%", "60%");
		}else{
			this.dialogRef.updateSize("100%", "80%");
		}
	
		this.servicioValoracione.obtenerDatosValoraciones().subscribe((data:any)=>{
			this.dataValoraciones=data.valoraciones;
		});
		this.servicioRepuesto.obtenerDatosRepuestos().subscribe((data:any)=>{
			this.dataRepuestos=data.repuestos;
		});
	
		this.formInsertarRepuestosvaloracione = this.fb.group({
			valoracione_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
			repuesto_id:[null,Validators.compose([Validators.required,CustomValidators.number])],
			precioventa:[null,Validators.compose([Validators.required,CustomValidators.number])],
			estado:[1,null],
		});
	}


	saveRepuestosvaloracione(){
		let repuestosvaloracioneDataModel:Repuestosvaloraciones=this.formInsertarRepuestosvaloracione.value;
		this.servicioRepuestosvaloracione.guardarRepuestosvaloraciones(repuestosvaloracioneDataModel).subscribe((data:any)=>{
			if(data.estado){
				this.mensajes.setNotification(data).then((datas)=>{
					if(datas){
						this.dialogRef.close(1);
					}
				});
			}else{
				this.mensajes.setNotification(data);
			}
		});
	}


	onResize(event){
		this.breakpoint = (event.target.innerWidth <= 800) ? 1 : 2;
		this.ratio=(event.target.innerWidth <= 800) ? '4:1.6':'4:1';
		if(this.breakpoint!=1){
			this.dialogRef.updateSize("50%", "60%");
		}else{
			this.dialogRef.updateSize("100%", "80%");
		}
	}

	cerrarModal(){
		this.dialogRef.close(2);
	}
}

MatDialogRef.prototype.updateSize = function (width, height) {
	if (width === void 0) { width = 'auto'; }
	if (height === void 0) { height = 'auto'; }
	this._getPositionStrategy().width(width).height(height);
	this._overlayRef.updatePosition();
	return this;
};